import PaymentsPage from './views/PaymentsPage.vue';
import PaymentsModule from './PaymentsModule.vue';
import RequestKeyPage from './views/RequestKeyPage.vue';
export const paymentModuleRoutes = [
  {
    path: '/payments',
    name: 'Payments',
    component: PaymentsModule,
    children: [
      {
        path: '',
        name: 'Payments.Plans',
        component: PaymentsPage
      },
      {
        path: 'requestKey',
        name: 'Payments.RequestKey',
        component: RequestKeyPage
      }
    ]
  }
];
